
export class PeremriConstants {

  public static PeremriGjinia = [
    { id: 10, short: "m.", long: "Mashkullore", longTolow: "mashkullore" },
    { id: 11, short: "f.", long: "Femërore", longTolow: "femërore" },
  ];

  public static PeremriGjinite = [
    { id: 10, short: "m.", long: "Mashkullore", longTolow: "mashkullore" },
    { id: 11, short: "f.", long: "Femërore", longTolow: "femërore" },
    { id: 12, short: "a.", long: "Asnjanëse", longTolow: "asnjanëse" },
  ]

  public static PeremriGjiniaMashkullore = [
    { id: 10, short: "m.", long: "Mashkullore" },
  ];

  public static PeremriGjiniaFemerore = [
    { id: 11, short: "f.", long: "Femërore" },
  ];

  public static PeremriLloji = [
    { id: 10, short: "v.", long: "Vetor" },
    { id: 11, short: "vv.", long: "Vetvetor" },
    { id: 12, short: "d.", long: "Dëftor" },
    { id: 13, short: "p.", long: "Pronor" },
    { id: 14, short: "pt.", long: "Pyetës" },
    { id: 15, short: "l.", long: "Lidhor" },
    { id: 16, short: "pc.", long: "I pacaktuar" },
    { id: 17, short: "t.", long: "Tjetër" },
  ];

  public static PeremriNumri = [
    { id: 10, short: "nj.", long: "Njëjës", longTolow: "njëjës" },
    { id: 11, short: "sh.", long: "Shumës", longTolow: "shumës" },
  ];

  public static PeremriNumriNjejes = [
    { id: 10, short: "nj.", long: "Njëjës" },
  ];

  public static PeremriNumriShumes = [
    { id: 11, short: "sh.", long: "Shumës" },
  ];

  public static PeremriVeta = [
    { id: 10, short: "v. I", long: "E parë" },
    { id: 11, short: "v. II", long: "E dytë" },
    { id: 12, short: "v. III", long: "E tretë" },
  ];

  public static PeremriVetaI = [
    { id: 10, short: "v. I", long: "Veta I" },
  ];

  public static PeremriVetaII = [
    { id: 11, short: "v. II", long: "Veta II" },
  ];

  public static PeremriVetaIII = [
    { id: 12, short: "v. III", long: "Veta III" },
  ];

  public static PronoriLloji = [
    { id: 11, short: "p. paez", long: "Pronori i paemërzuar" },
    { id: 10, short: "p. ez", long: "Pronori i emërzuar" }
  ]

  public static PeremriFormaFjales = [
    { id: 11, short: "s'", long: "s'" },
    { id: 10, short: "ç'", long: "ç'" },
  ]

  public static PeremriRasa = [
    { id: 10, short: "e.", long: "Emërore" },
    { id: 11, short: "gj.", long: "Gjinore (i,e,të,së)" },
    { id: 12, short: "dh.", long: "Dhanore" },
    { id: 13, short: "k.", long: "Kallëzore" },
    { id: 14, short: "rr.", long: "Rrjedhore (prej ...)" },
    { id: 15, short: "th.", long: "Thirrore" },
    { id: 16, short: "v.", long: "Vendore*" },
  ];


  public static PeremriRasatDisabled = [
    { id: 10, short: "e.", long: "Emërore", disabled: true },
    { id: 11, short: "gj.", long: "Gjinore (i,e,të,së)", disabled: true },
    { id: 12, short: "dh.", long: "Dhanore", disabled: false },
    { id: 13, short: "k.", long: "Kallëzore", disabled: false },
    { id: 14, short: "rr.", long: "Rrjedhore (prej ...)", disabled: true },
  ];

  public static PeremriRasat = [
    { id: 10, short: "E.", long: "Emërore" },
    { id: 11, short: "Gj. (i...)", long: "Gjinore (i,e,të,së)" },
    { id: 12, short: "Dh.", long: "Dhanore" },
    { id: 13, short: "K.", long: "Kallëzore" },
    { id: 14, short: "Rr. (prej...)", long: "Rrjedhore  (prej ...)" },
  ];

  public static PeremriRasatEmerore = [
    { id: 10, short: "E.", long: "Emërore" },
  ];


  public static PeremriLlojiParametri = [
    { id: 10, short: "v. I nj.", long: "Veta I, njëjës" },
    { id: 11, short: "v. I sh.", long: "Veta I, shumës" },
    { id: 12, short: "v. II nj.", long: "Veta II, njëjës" },
    { id: 13, short: "v. II sh.", long: "Veta II, shumës" },
    { id: 14, short: "v. III nj. m.", long: "Veta III, njëjës, mashkullore" },
    { id: 15, short: "v. III nj. f.", long: "Veta III, njëjës, femërore" },
    { id: 16, short: "v. III sh. m.", long: "Veta III, shumës, mashkullore" },
    { id: 17, short: "v. III sh. f.", long: "Veta III, shumës, femërore" },
    { id: 18, short: "r.", long: "Rasë" },
    { id: 19, short: "m. pn.", long: "Mashkullore, i panyjshëm" },
    { id: 20, short: "f. pn.", long: "Femërore, i panyjshëm" },
    { id: 21, short: "a. pn.", long: "Asnjanës, i panyjshëm" },
    { id: 22, short: "m. n.", long: "Mashkullore, i nyjshëm" },
    { id: 23, short: "f. n.", long: "Femërore, i nyjshëm" },
    { id: 24, short: "a. n.", long: "Asnjanës, i nyjshëm" },
    { id: 25, short: "p. v. I nj.", long: "Veta I, njëjës" },
    { id: 26, short: "p. v. I sh.", long: "Veta I, shumës" },
    { id: 27, short: "p. v. II nj.", long: "Veta II, njëjës" },
    { id: 28, short: "p. v. II sh.", long: "Veta II, shumës" },
    { id: 29, short: "p. v. III nj. m.", long: "Veta III, njëjës, mashkullore" },
    { id: 30, short: "p. v. III nj. f.", long: "Veta III, njëjës, femërore" },
    { id: 31, short: "v. III nj. a.", long: "Veta III, njëjës, asnjanëse" },
    { id: 32, short: "p. vv. nj. m.", long: "Pronori vetvetor, njëjës, mashkullore" },
    { id: 33, short: "p. vv. nj. f.", long: "Pronori vetvetor, njëjës, femërore" },
    { id: 34, short: "p. vv. nj. a.", long: "Pronori vetvetor, njëjës, asnjanëse" },
    { id: 35, short: "p. v. III sh. m.", long: "Veta III, shumës, mashkullore" },
    { id: 36, short: "p. v. III sh. f.", long: "Veta III, shumës, femërore" },
    { id: 37, short: "p. vv. sh. m.", long: "Pronori vetvetor, shumës mashkullore" },
    { id: 38, short: "p. vv. sh. f.", long: "Pronori vetvetor, shumës femërore" },
    { id: 39, short: "py. m. pn.", long: "Mashkullore, i panyjshëm" },
    { id: 40, short: "py. f. pn.", long: "Femërore, i panyjshëm" },
    { id: 41, short: "py. a. pn.", long: "Asnjanës, i panyjshëm" },
    { id: 42, short: "py. m. n.", long: "Mashkullore, i nyjshëm" },
    { id: 43, short: "py. f. n.", long: "Femërore, i nyjshëm" },
    { id: 44, short: "py. a. n.", long: "Asnjanës, i nyjshëm" },
    { id: 45, short: "py. r.", long: "Rasë" },
    { id: 46, short: "gj.", long: "Gjini" },
    { id: 47, short: "p. v.", long: "Pa veçori" },
    { id: 48, short: "l. m. n.", long: "Mashkullore, i nyjshëm" },
    { id: 49, short: "l. f. n.", long: "Femërore, i nyjshëm" },
    { id: 50, short: "l. a. n.", long: "Asnjanës, i nyjshëm" },
    { id: 51, short: "l. m. pn.", long: "Mashkullore, i panyjshëm" },
    { id: 52, short: "l. f. pn.", long: "Femërore, i panyjshëm" },
    { id: 53, short: "l. a. pn.", long: "Asnjanës, i panyjshëm" },
    { id: 54, short: "l. r.", long: "Rasë" },
    { id: 55, short: "l. p. v.", long: "Pa veçori" },
    { id: 56, short: "m.", long: "Mashkullore" },
    { id: 57, short: "f.", long: "Femërore" },
    { id: 58, short: "a.", long: "Asnjanëse" },
    { id: 59, short: "pa. r.", long: "Rasë" },
    { id: 60, short: "r. m.", long: "Rasë, mashkullore" },
    { id: 61, short: "r. f.", long: "Rasë, femërore" },
    { id: 62, short: "pa. p. v.", long: "Pa veçori" },
  ];

  public static PeremriLloji10Parametri = [
    { id: 10, short: "v. I nj.", long: "Veta I, njëjës" },
    { id: 11, short: "v. I sh.", long: "Veta I, shumës" },
    { id: 12, short: "v. II nj.", long: "Veta II, njëjës" },
    { id: 13, short: "v. II sh.", long: "Veta II, shumës" },
    { id: 14, short: "v. III nj. m.", long: "Veta III, njëjës, mashkullore" },
    { id: 15, short: "v. III nj. f.", long: "Veta III, njëjës, femërore" },
    { id: 16, short: "v. III sh. m.", long: "Veta III, shumës, mashkullore" },
    { id: 17, short: "v. III sh. f.", long: "Veta III, shumës, femërore" },
  ]

  public static PeremriLloji11Parametri = [
    { id: 18, short: "r.", long: "Rasë" },
  ]

  public static PeremriLloji12Parametri = [
    { id: 19, short: "m. pn.", long: "Mashkullore, i panyjshëm" },
    { id: 20, short: "f. pn.", long: "Femërore, i panyjshëm" },
    { id: 21, short: "a. pn.", long: "Asnjanës, i panyjshëm" },
    { id: 22, short: "m. n.", long: "Mashkullore, i nyjshëm" },
    { id: 23, short: "f. n.", long: "Femërore, i nyjshëm" },
    { id: 24, short: "a. n.", long: "Asnjanës, i nyjshëm" },
  ]

  public static PeremriLloji13Parametri = [
    { id: 10, short: "p. v. I nj.", long: "Veta I, njëjës" },
    { id: 11, short: "p. v. I sh.", long: "Veta I, shumës" },
    { id: 12, short: "p. v. II nj.", long: "Veta II, njëjës" },
    { id: 13, short: "p. v. II sh.", long: "Veta II, shumës" },
    { id: 14, short: "p. v. III nj. m.", long: "Veta III, njëjës, mashkullore" },
    { id: 15, short: "p. v. III nj. f.", long: "Veta III, njëjës, femërore" },
    { id: 25, short: "v. III nj. a.", long: "Veta III, njëjës, asnjanëse" },
    { id: 26, short: "p. vv. nj. m.", long: "Pronori vetvetor, njëjës, mashkullore" },
    { id: 27, short: "p. vv. nj. f.", long: "Pronori vetvetor, njëjës, femërore" },
    { id: 28, short: "p. vv. nj. a.", long: "Pronori vetvetor, njëjës, asnjanëse" },
    { id: 16, short: "p. v. III sh. m.", long: "Veta III, shumës, mashkullore" },
    { id: 17, short: "p. v. III sh. f.", long: "Veta III, shumës, femërore" },
    { id: 29, short: "p. vv. sh. m.", long: "Pronori vetvetor, shumës mashkullore" },
    { id: 30, short: "p. vv. sh. f.", long: "Pronori vetvetor, shumës femërore" },
  ]

  public static PeremriLloji14Parametri = [
    { id: 19, short: "py. m. pn.", long: "Mashkullore, i panyjshëm" },
    { id: 20, short: "py. f. pn.", long: "Femërore, i panyjshëm" },
    { id: 21, short: "py. a. pn.", long: "Asnjanës, i panyjshëm" },
    { id: 22, short: "py. m. n.", long: "Mashkullore, i nyjshëm" },
    { id: 23, short: "py. f. n.", long: "Femërore, i nyjshëm" },
    { id: 24, short: "py. a. n.", long: "Asnjanës, i nyjshëm" },
    { id: 18, short: "py. r.", long: "Rasë" },
    { id: 31, short: "gj.", long: "Gjini" },
    { id: 32, short: "p. v.", long: "Pa veçori" },
  ]

  public static PeremriLloji15Parametri = [
    { id: 22, short: "l. m. n.", long: "Mashkullore, i nyjshëm" },
    { id: 23, short: "l. f. n.", long: "Femërore, i nyjshëm" },
    { id: 24, short: "l. a. n.", long: "Asnjanës, i nyjshëm" },
    { id: 19, short: "l. m. pn.", long: "Mashkullore, i panyjshëm" },
    { id: 20, short: "l. f. pn.", long: "Femërore, i panyjshëm" },
    { id: 21, short: "l. a. pn.", long: "Asnjanës, i panyjshëm" },
    { id: 18, short: "l. r.", long: "Rasë" },
    { id: 32, short: "l. p. v.", long: "Pa veçori" },
  ]

  public static PeremriLloji16Parametri = [
    { id: 33, short: "m.", long: "Mashkullore" },
    { id: 34, short: "f.", long: "Femërore" },
    { id: 35, short: "a.", long: "Asnjanëse" },
    { id: 18, short: "pa. r.", long: "Rasë" },
    { id: 36, short: "r. m.", long: "Rasë, mashkullore" },
    { id: 37, short: "r. f.", long: "Rasë, femërore" },
    { id: 32, short: "pa. p. v.", long: "Pa veçori" },
  ]

  public static PeremriRenditja = [
    { id: 10, short: "e. + p. d.", long: "Emër + përemër dëftor" },
    { id: 11, short: "p. d. + e.", long: "Përemër dëftor + emër" },
  ];

  public static PeremriTrajta = [
    { id: 11, short: "pashq.", long: "E pashquar" },
    { id: 10, short: "shq.", long: "E shquar" },
  ];

  public static PeremriTrajtaShquar = [
    { id: 10, short: "shq.", long: "e shquar" },
  ];


  public static PeremriTrajtaPaShquar = [
    { id: 11, short: "pashq.", long: "e pashquar" },
  ];


  public static PeremriTrajtatEShkurtraTeBashkuaraKolonat = [
    { id: 10, short: "dh. I nj. k. III nj.", long: "dhanore, I, njëjës + kallëzore, III, njëjës" },
    { id: 16, short: "dh. I nj. k. III sh.", long: "Dhanore, I, Njëjës, Kallëzore, III, Shumës" },
    { id: 13, short: "dh. I sh. k. III nj.", long: "Dhanore, I, Shumës, Kallëzore, III, Njëjës" },
    { id: 19, short: "dh. I sh. k. III sh.", long: "Dhanore, I, Shumës, Kallëzore, III, Shumës" },
    { id: 11, short: "dh. II nj. k. III nj.", long: "Dhanore, II, Njëjës, Kallëzore, III, Njëjës" },
    { id: 17, short: "dh. II nj. k. III sh.", long: "Dhanore, II, Njëjës, Kallëzore, III, Shumës" },
    { id: 14, short: "dh. II sh. k. III nj.", long: "Dhanore, II, Shumës, Kallëzore, III, Njëjës" },
    { id: 20, short: "dh. II sh. k. III sh.", long: "Dhanore, II, Shumës, Kallëzore, III, Shumës" },
    { id: 12, short: "dh. III nj. k. III nj.", long: "Dhanore, III, Njëjës, Kallëzore, III, Njëjës" },
    { id: 18, short: "dh. III nj. k. III sh.", long: "Dhanore, III, Njëjës, Kallëzore, III, Shumës" },
    { id: 15, short: "dh. III sh. k. III nj.", long: "Dhanore, III, Shumës, Kallëzore, III, Njëjës" },
    { id: 21, short: "dh. III sh. k. III sh.", long: "Dhanore, III, Shumës, Kallëzore, III, Shumës" },
    { id: 22, short: "dh. III m. nj. k. III nj.", long: "Dhanore, III, Mashkullore, Njejes, Kallezore, III, Njejes" },
    { id: 23, short: "dh. III f. nj. k. III nj.", long: "Dhanore, III, Femerore, Njejes, Kallezore, III, Njejes" },
    { id: 24, short: "dh. III m. sh. k. III nj.", long: "Dhanore, III, Mashkullore, Shumes, Kallezore, III, Njejes" },
    { id: 25, short: "dh. III f. sh. k. III nj.", long: "Dhanore, III, Femerore, Shumes, Kallezore, III, Njejes" },
    { id: 26, short: "dh. III m. nj. k. III sh.", long: "Dhanore, III, Mashkullore, Njejes, Kallezore, III, Shumes" },
    { id: 27, short: "dh. III f. nj. k. III sh.", long: "Dhanore, III, Femerore, Njejes, Kallezore, III, Shumes" },
    { id: 28, short: "dh. III m. sh. k. III sh.", long: "Dhanore, III, Mashkullore, Shumes, Kallezore, III, Shumes" },
    { id: 29, short: "dh. III f. sh. k. III sh.", long: "Dhanore, III, Femerore, Shumes, Kallezore, III, Shumes" },
  ];

  public static PeremriTrajtatEShkurtraTeBashkuaraKolonatVetaIIINjejes = [
    {
      id: 10,
      short: "dh. I nj. k. III nj.",
      long: "dhanore, I, njëjës+kallëzore, III, njëjës",
    },
    {
      id: 13,
      short: "dh. I sh. k. III nj.",
      long: "dhanore, I, shumës+kallëzore, III, njëjës",
    },
    {
      id: 11,
      short: "dh. II nj. k. III nj.",
      long: "dhanore, II, njëjës+kallëzore, III, njëjës",
    },
    {
      id: 14,
      short: "dh. II sh. k. III nj.",
      long: "dhanore, II, shumës+kallëzore, III, njëjës",
    },
    {
      id: 22,
      short: "dh. III m. nj. k. III nj.",
      long: "dhanore, III, mashkullore, njëjës+kallëzore, III, njëjës",
    },
    {
      id: 23,
      short: "dh. III f. nj. k. III nj.",
      long: "dhanore, III, femërore, njëjës+kallëzore, III, njëjës",
    },
    {
      id: 24,
      short: "dh. III m. sh. k. III nj.",
      long: "dhanore, III, mashkullore, shumës+kallëzore, III, njëjës",
    },
    {
      id: 25,
      short: "dh. III f. sh. k. III nj.",
      long: "dhanore, III, femërore, shumës+kallëzore, III, njëjës",
    },
  ];

  public static PeremriTrajtatEShkurtraTeBashkuaraKolonatVetaIIIShumes = [
    {
      id: 16,
      short: "dh. I nj. k. III sh.",
      long: "dhanore, I, njëjës+kallëzore, III, shumës",
    },
    {
      id: 19,
      short: "dh. I sh. k. III sh.",
      long: "dhanore, I, shumës+kallëzore, III, shumës",
    },
    {
      id: 17,
      short: "dh. II nj. k. III sh.",
      long: "dhanore, II, njëjës+kallëzore, III, shumës",
    },
    {
      id: 20,
      short: "dh. II sh. k. III sh.",
      long: "dhanore, II, shumës+kallëzore, III, shumës",
    },
    {
      id: 26,
      short: "dh. III m. nj. k. III sh.",
      long: "dhanore, III, mashkullore, njëjës+kallëzore, III, shumës",
    },
    {
      id: 27,
      short: "dh. III f. nj. k. III sh.",
      long: "dhanore, III, femërore, njëjës+kallëzore, III, shumës",
    },
    {
      id: 28,
      short: "dh. III m. sh. k. III sh.",
      long: "dhanore, III, mashkullore, shumës+kallëzore, III, shumës",
    },
    {
      id: 29,
      short: "dh. III f. sh. k. III sh.",
      long: "dhanore, III, femërore, shumës+kallëzore, III, shumës",
    },
  ];

}
